module.exports = __webpack_public_path__ + "assets/img/mecha-btn-551bcf18.png";